<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="back">
          <div class="title">
            <img src="./assets/logo_title.png"/>
          </div>
        </div>
        <div class="split"></div>
        <el-divider></el-divider>
      </el-header>
      <el-main>
        <HelloWorld msg="基里尔蒙古文与传统蒙古文转换系统"/>
      </el-main>
      <el-footer>
        <div>研究机构：内蒙古鼎文科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;内蒙古互特启文化传播有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;多语种文化信息数字化技术研究中心</div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    HelloWorld
  }
}
</script>

<style  lang="scss">
  html{
    height: 100%;
  }
  body{
    height: calc(100% - 16px);
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
.el-container{
  height: 100%;
  .el-header{
    height: 129px !important;
    padding: 0 !important;
    .back{
      background-color: #01559A;
      height: 120px;
      .title{
        padding-top: 10px;
        padding-left: 200px;
        text-align: left;
      }
    }
    .split{
      height: 4px;
    }
    .el-divider{
      margin: 0;
      height: 5px;
      background-color: #01559A;
    }
  }
  .el-main{
  }
  .el-footer{
    background-color: #01559A;
    color:#fff;
    font-size: 12px;
    div{
      padding-top: 22px;
    }
  }
}

</style>
